module.exports = {
  SEARCH_COOKIE: 'ha-trip-prst'
};
